import React from 'react'

import ErrorMessage from '@/components/misc/ErrorMessage/ErrorMessage'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  error: unknown
  fallbackComponent?: React.ReactNode
  cardProps?: React.ComponentProps<typeof Card>
}

const FullPageErrorFallback: React.FC<Props> = ({
  className,
  style,
  error,
  fallbackComponent,
  cardProps,
}) => {
  if (fallbackComponent) {
    return fallbackComponent
  }

  return (
    <div
      className={cn(
        'mx-auto mt-12 flex max-w-200 justify-center p-6',
        className,
      )}
      style={{ ...style }}
    >
      <Card {...cardProps} className={cn('w-full', cardProps?.className)}>
        <CardContent>
          <ErrorMessage error={error} />
        </CardContent>
      </Card>
    </div>
  )
}

export default FullPageErrorFallback
